var SDK_VERSION = '7.8.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
